import Vue from "vue";
import Vuex from "vuex";

import grids from "./modules/widgets/grids";
import modals from "./modules/widgets/modals";
import sidebarRight from "./modules/widgets/sidebarRight";

import captcha from "./modules/captchaModule";
import password from "./modules/passwordModule";
import account from "./modules/accountModule";
import user from "./modules/userModule";
import profiles from "./modules/profilesModule";
import help from "./modules/helpModule";
import unities from "./modules/unitiesModule";
import patients from "./modules/patientsModule";
import procedures from "./modules/proceduresModule";
import solicitations from "./modules/solicitationsModule";
import professionals from "./modules/professionalsModule";
import schedules from "./modules/schedulesModule";
import regulations from "./modules/regulationsModule";
import reports from "./modules/reportsModule";
import login from "./modules/loginModule";
import protocols from "./modules/protocolsModule";
import assessments from "./modules/assessmentsModule";
import documents from "./modules/documentsModule";
import logs from "./modules/logsModule";
import judicialDecisions from "./modules/judicialDecisionsModule";
import electiveSurgeries from "./modules/electiveSurgeriesModule";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // WIDGETS
    grids,
    modals,
    sidebarRight,

    // MODULES
    captcha,
    password,
    account,
    user,
    profiles,
    help,
    unities,
    patients,
    procedures,
    solicitations,
    professionals,
    schedules,
    regulations,
    reports,
    login,
    protocols,
    assessments,
    documents,
    logs,
    judicialDecisions,
    electiveSurgeries,
  },
});
